import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getCategoryId from '../selector/getCategoryId';
import { setGtmPauseEventsAction, setGtmProductsDataAction } from '../slice';

const fetchGTMProductsDataOperation =
  (encDesignIds: string[]) => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    if (!encDesignIds?.length) {
      return null;
    }

    const store = getState();
    const categoryId = getCategoryId(store) || 1;
    const quantity = 1;

    dispatch(setGtmPauseEventsAction(true));
    const gtmProducts = (await apiRequest(
      endpoints.categoryGtmProducts,
      {
        categoryId,
        designIds: encDesignIds.join(','),
        quantity,
      },
      HttpMethods.GET,
      'payload',
    )) as any[];

    dispatch(
      setGtmProductsDataAction({
        gtmProducts,
        merge: true,
      }),
    );
    dispatch(setGtmPauseEventsAction(false));

    return null;
  };

export default fetchGTMProductsDataOperation;
